import { getHealthScoreCardColor, isUndefined, resolvedAlert } from '@common/utils'
import React, {useState} from 'react'
import {Button, Card, CardBody, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table} from 'reactstrap'
import { Heart, Slash, Bell } from 'react-feather'
import '@assets/scss/components/dashboard.scss'

export default ({ shop, equipment, iotData }) => {
    return (
        <Col lg='3' md='3' sm='12'>
            <Card className='temp-container'>
                <CardBody>
                    <ScoreCard
                        icon={<Heart />}
                        text='Health Score'
                        value={iotData?.healthScore || null}
                        unit='%'
                        color={getHealthScoreCardColor(iotData?.healthScore || null)}
                    />
                    <ScoreCard
                        icon={<Slash />}
                        text='% To Failure'
                        value={iotData?.failure || null}
                        unit='%'
                    />
                    <AlertScoreCard data={iotData} shopData={shop} equipmentData={equipment} />
                </CardBody>
            </Card>
        </Col>
    )
}

const ScoreCard = ({ icon, text, value, unit, color }) => {

    return (
        <div className={`temp-card-body stats-card-body d-flex justify-content-between 
                        flex-row-reverse`}>
            <div className='icon-section'>
                <div className={`avatar avatar-stats p-50 m-0 mt-0 bg-rgba-${color}`} >
                    <div className={`avatar-content ${color}`}>{icon}</div>
                </div>
            </div>
            <div className='title-section'>
                <h2 className={`text-bold-600 mt-0 mb-25 ${color}`}>
                    {isUndefined(value) ? '-' : value + (unit || '')}
                </h2>
                <p className={`mb-0 ${color}`}>{text}</p>
            </div>
        </div>
    )
}



const AlertScoreCard = ({ data, shopData, equipmentData }) => {

    //region Alert Modal
    const [modalAlertOpen, setModalAlertOpen] = useState(false)
    const [modalData, setModalData] = useState({})
    const toggleModalAlert = () => {
        setModalAlertOpen(!modalAlertOpen)
    }

    const onModalAlertClick = (data) => {
        setModalData(data)
        toggleModalAlert()
    }

    const renderAlertModal = () => {
        return (
            <Modal
                isOpen={modalAlertOpen}
                toggle={toggleModalAlert}
                className='modal-lg'

            >
                <ModalHeader toggle={toggleModalAlert} className='w-100 modal-danger'
                             close={null}
                >
                    <Row className='w-100'>
                        <Col sm={'5'}>
                            <div>
                                <span className='text-bold-500'>{equipmentData.assetNo}</span>
                            </div>
                            <div>
                                <span className='text-bold-400' style={{ color: '#C8C8C8' }}>{equipmentData.serial}</span>
                            </div>
                        </Col>
                        <Col sm={'5'}>
                            <div>
                                <span className='text-bold-500'>{shopData.branchNo} {shopData.ShopBrand.code}</span>
                            </div>
                            <div>
                                <span className='text-bold-400' style={{ color: '#C8C8C8' }}>{shopData.detail}</span>
                            </div>
                        </Col>
                        <Col sm={'2'}>
                            <div className='text-right'>
                                <div className='icon-section'>
                                    <div
                                        className={`avatar avatar-stats p-50 m-0 bg-rgba-danger`}
                                    >
                                        <div className='avatar-content'><Bell className='danger' size={22} /></div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </ModalHeader>
                <ModalBody className='dashboard-alert-table'>
                    <Table
                        size='small'
                        responsive>
                        <thead style={{ backgroundColor: '#F3F2F7' }}>
                        <tr>
                            <th style={{ width: '180px' }}>Item</th>
                            <th>Alarm Message</th>
                            <th style={{ width: '120px' }}>Alert Type</th>
                            <th style={{ width: '120px' }}>No. Alert</th>
                        </tr>
                        </thead>
                        {
                            modalData && modalData.length > 0 ? <tbody>
                            {
                                modalData.map((x, index) => {
                                    return (<tr>
                                        <td>{index + 1}</td>
                                        <td>{x.reason}</td>
                                        <td>{x.type}</td>
                                        <td className='dashboard-alert-number'>{x.count_alert}</td>
                                    </tr>)
                                })
                            }
                            </tbody> : null
                        }

                    </Table>
                </ModalBody>
                <ModalFooter style={{ display: 'block' }} >
                    <div className='justify-content-end text-right'>
                        <Button color='primary' onClick={toggleModalAlert}>
                            Close
                        </Button>{' '}
                    </div>

                </ModalFooter>
            </Modal>
        )
    }
    //endregion Alert Modal
    let alert_lenght = data && data.alertReason ? data.alertReason.length : 0
    const alertScoreCard =
        <>
            <ScoreCard
                icon={<Bell onClick={() => onModalAlertClick(data.alertReason)}/>}
                text='Alert'
                value={data && data.alertReason ? data.alertReason.length : '- '}
                color={alert_lenght > 0 ? 'danger' : ''}
            />

            {renderAlertModal()}
        </>
    return alertScoreCard
}

